<!--消缺管理界面-->
<template>
  <div class="newobviateDefectsManage">
    <div class="con">
      <div class="left-tree">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
        <el-scrollbar style="height:95%;width: 100%;">
          <el-tree :data="archivesTypeList" :default-expanded-keys="[2]" :expand-on-click-node="true" node-key="id"
            :props="defaultProps" :highlight-current='true' :filter-node-method="filterNode" ref="tree"
            @node-click="checkItem">
            <span class="custom-tree-node" slot-scope="{node,data}">
              <img src="../../../../public/static/image/elTree/2.1.png" v-if="data.typeEnum ==3" />
              <img src="../../../../public/static/image/elTree/2.0.png" v-else />
              <span style="padding:0px  5px;">{{node.label }}</span>
            </span>
          </el-tree>
        </el-scrollbar>
      </div>
      <div class="right-tbale">
        <div class="search-input-btn">
          <el-scrollbar style="height:100%;width: 100%;">
            <div class="my-search-i">
              <div class="input-small mr-20">
                <span>名称：</span>
                <el-input v-model="searchName" placeholder="请输入消缺名称"></el-input>
              </div>
              <div class="input-small myinput mr-20">
                <span>缺陷等级：</span>
                <el-select v-model="searchPriority" clearable placeholder="请选择">
                  <el-option v-for="item in priorityList" :key="item.value" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="input-small myinput mr-20">
                <span>执行状态：</span>
                <el-select v-model="searchExecutorStatus" clearable placeholder="请选择">
                  <el-option v-for="item in executorStatusList" :key="item.value" :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="input-small myinput">
                <span>执行类型：</span>
                <el-select v-model="searchExecutorType" clearable placeholder="请选择">
                  <el-option v-for="item in executorTypeList" :key="item.value" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <el-button type="primary" size="mini" plain @click="searchName_fn" class="search-btn">查询</el-button>
              <el-button type="primary" size="mini" @click="add_ed" class="last-el-button search-btn">新建消缺</el-button>
            </div>
          </el-scrollbar>
        </div>
        <div class="mytable" :style="{'height':heights+'px'}">
          <el-table ref="multipleTable" :data="nowPageDataList" tooltip-effect="dark" :max-height="heights - 20"
            style="width: 100%" border>
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column width="75" label="序号" align="center" fixed>
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="消缺名称" prop="name" fixed width="150"> </el-table-column>
            <el-table-column label="创建人" prop="createUser" width="120"> </el-table-column>
            <el-table-column prop="priority" label="缺陷等级" width="120" align="center">
              <template #default="{row}">
                <!-- {{row.priority | priorityfun}} -->
                <div class="public-flex">
                  <span class="myemergent mutongyong" v-if="row.priority =='Emergent'">紧急</span>
                  <span class="myhigh mutongyong" v-if="row.priority =='High'">高</span>
                  <span class="mystandard mutongyong" v-if="row.priority =='Standard'">标准</span>
                  <span class="mylow mutongyong" v-if="row.priority =='Low'">低</span>
                  <span v-if="row.priority =='--'">--</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="harm" label="缺陷危害" width="120"> </el-table-column>
            <el-table-column prop="proposal" label="处理建议" width="120"> </el-table-column>
            <el-table-column label="处理状态" width="120" align="center">
              <template #default="{row}">
                <div class="chuli public-flex" v-if="row.executorStatus =='EXECUTORY'">
                  <p></p><span>处理中</span>
                </div>
                <div class="patrol public-flex" v-if="row.executorStatus =='FINISHED'">
                  <p></p><span>已完结</span>
                </div>
                <div class="overhaul public-flex" v-if="row.executorStatus=='INITIAL'">
                  <p></p><span>未处理</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="executorTime" label="处理时间" width="200">
              <template #default="{row}">
                <span>
                  {{row.executorTime | date_format}}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="executorType" label="处理类型" width="120">
              <template #default="{row}">
                <span>
                  {{row.executorType | executorType_fn}}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="executorUser" label="处理人" width="120"> </el-table-column>
            <el-table-column label="操作" align="center" width="300" fixed="right">
              <template #default="{row}">
                <span class="buttoned_box">
                  <el-button type="text" @click="createJob(row)"
                    style="color:#409eff;font-weight: bold">创建工单</el-button>
                  <el-popconfirm title="确定要手动处理此消缺吗？" @onConfirm='handle_fn(row)'>
                    <template #reference>
                      <el-button slot="reference" type="text" style="color:#409eff;font-weight: bold"
                        v-show="typeEnum == 3 && row.executorType == 'UNKNOWN'">处理</el-button>
                    </template>
                  </el-popconfirm>
                  <el-button type="text" @click="handle_fn(row)" style="color:#409eff;font-weight: bold">处理</el-button>

                  <el-button type="text" @click="edit_ed(row)" style="color:#409eff;font-weight: bold">编辑</el-button>

                  <el-button type="text" @click="deleteDefect_fn(row)"
                    style="color:#FF7765;font-weight: bold">删除</el-button>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="divider-line"></div>
        <div class="paging">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" background :page-sizes="[10, 20, 30, 40, 50]" :page-size="10"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
      <el-dialog :title="textMap[dialogStatus]" :close-on-click-modal='false' v-dialogDrag :visible.sync="dialogVisible"
        width="50%">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
          <el-form-item label="消缺名称" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="缺陷等级" prop="priority">
            <el-select v-model="form.priority" clearable placeholder="请选择">
              <el-option v-for="item in priorityList" :key="item.value" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据类型" prop="valueType">
            <el-select v-model="form.valueType" clearable placeholder="请选择">
              <el-option v-for="item in valueTypeList" :key="item.value" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="缺陷危害" prop="harm">
            <el-input type="textarea" v-model="form.harm" resize="none"></el-input>
          </el-form-item>
          <el-form-item label="处理建议" prop="proposal">
            <el-input type="textarea" v-model="form.proposal" resize="none"></el-input>
          </el-form-item>
          <el-form-item label="消缺设备" prop="typeCode">
            <!-- prop="typeCode" -->
            <el-select v-model="form.standingBookId" clearable placeholder="请选择" @change="deviceChang_fn">
              <el-option v-for="item in archivesList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="dialogStatus==='edit'?edit_fn('form'):add_fn('form')">保
            存</el-button>
        </span>
      </el-dialog>
      <!-- 通过消缺创建工单 -->
      <div class="defects-create" v-if="defectsFlag">
        <createOrder ref="createOrderBean" :nowDefecList="nowDefecList" @returnToList="returnToList"></createOrder>
      </div>
    </div>
  </div>
</template>

<script>
  import UpdateDefectDialog from './UpdateDefectDialog.vue';
  import createOrder from '@/page/order/createOrder/defectCreateOrder.vue';

  import {getArchivesListByTypeCodeAndGroupNo,saveDefect,deleteDefect,findDefectActionList,executorStatus} from "../../../api/abbNewApi"
  export default {
    components: {
      UpdateDefectDialog,
      createOrder
    },
    props: {},
    data () {
      return {
        loading: false,
        heights: Math.round((document.getElementById('app').clientHeight)*0.75),//屏幕高度 - 导航栏高度
        defectsFlag: false,
        searchPriority: null,
        searchName: "",
        zhongArr: [],
        nowDefecList: {},
        //新建编辑消缺弹窗
        dialogVisible: false,
        form: {
          name: '',
          priority: '',
          valueType: '',
          harm: '',
          proposal: '',
          defectType: 'check',
          device: [],
          typeCode: '',
          typeName: '',
          standingBookId: ""
        },
        rules: {
          name: [
            {required: true,message: '请输入消缺名称',trigger: 'blur'},
            {min: 1,max: 20,message: '长度在 1 到 20 个字符',trigger: 'blur'}
          ],
          priority: [
            {required: true,message: '请选择缺陷等级',trigger: 'blur'}
          ],
          valueType: [
            {required: true,message: '请选择数据类型',trigger: 'blur'}
          ],
          harm: [
            {required: true,message: '缺陷危害内容不能为空',trigger: 'blur'},
          ],
          proposal: [
            {required: true,message: '处理建议内容不能为空',trigger: 'blur'},
          ],
          standingBookId: [
            {required: true,message: '请选择设备台账',trigger: 'blur'},
          ],
        },
        dialogStatus: '',
        textMap: {
          add: "新增消缺",
          edit: "编辑消缺"
        },
        archivesList: [],

        searchExecutorStatus: null,
        executorStatusList: [
          {
            'name': "未处理",
            value: 'INITIAL'
          },
          {
            'name': "处理中",
            value: 'EXECUTORY'
          },
          {
            'name': "已完结",
            value: 'FINISHED'
          },
        ],
        searchExecutorType: null,
        executorTypeList: [

          {
            'name': "人工",
            value: 'ARTIFICIAL'
          },
          {
            'name': "工单",
            value: 'ORDER'
          },
          {
            'name': "未知",
            value: 'UNKNOWN'
          },
        ],
        total: 0,
        currentPage: 1,
        currentSize: 10,
        nowEntity: {},
        history: {},

        dataList: [],
        dataListCopy: [],
        nowPageDataList: [
          {
            "pkid": 258494477387777,
            "name": "11",
            "priority": "High",
            "defectType": "check",
            "harm": "1",
            "proposal": "1",
            "typeCode": "yjsbyq",
            "valueType": "Text",
            "standingBookId": "e398e0ff763b414e8910f2331c96f4a2",
            "standingBookName": null,
            "deviceNo": 3,
            "deviceName": "永兴旺",
            "createUser": "7",
            "executorStatus": "FINISHED",
            "executorType": "ARTIFICIAL",
            "executorUser": "7",
            "executorTime": 1679035976000,
            "orderNo": null
          },
          {
            "pkid": 258494602883073,
            "name": "33",
            "priority": "Emergent",
            "defectType": "check",
            "harm": "33",
            "proposal": "33",
            "typeCode": "yjsbyq",
            "valueType": "Varchar",
            "standingBookId": "6aa1366f59f640d8a71084c75c2beb3c",
            "standingBookName": null,
            "deviceNo": 2,
            "deviceName": "奇源",
            "createUser": "7",
            "executorStatus": "INITIAL",
            "executorType": "UNKNOWN",
            "executorUser": "7",
            "executorTime": 1679036015000,
            "orderNo": 258494750230529
          },
          {
            "pkid": 260225984192513,
            "name": "23",
            "priority": "Standard",
            "defectType": "Varchar",
            "harm": "23",
            "proposal": "234",
            "typeCode": "yjsbyq",
            "valueType": "Float",
            "standingBookId": "6aa1366f59f640d8a71084c75c2beb3c",
            "standingBookName": null,
            "deviceNo": 6,
            "deviceName": "永宁机电1数显表",
            "createUser": "1",
            "executorStatus": "INITIAL",
            "executorType": "UNKNOWN",
            "executorUser": null,
            "executorTime": null,
            "orderNo": null
          },
          {
            "pkid": 306235097178113,
            "name": "电子设备",
            "priority": "Standard",
            "defectType": "Varchar",
            "harm": "设备损坏",
            "proposal": "维护",
            "typeCode": "yjsbyq",
            "valueType": "Float",
            "standingBookId": "1fa0f05d829440b8b7baf4864097872f",
            "standingBookName": "2",
            "deviceNo": 6,
            "deviceName": "永宁机电1数显表",
            "createUser": "1",
            "executorStatus": "INITIAL",
            "executorType": "UNKNOWN",
            "executorUser": null,
            "executorTime": null,
            "orderNo": null
          }
        ],
        props: {
          children: 'next',
          label: 'typeName',
          value: 'typeCode',
          expandTrigger: 'hover',
          checkStrictly: true
          //entityName:'entityName'
        },
        defaultProps: {
          children: 'next',
          label: 'typeName'
        },
        filterText: '',
        typeEnum: 0,
        nowArchives: {},
        treeArr: [],
        nameArr: [],
        nameStr: ""
      };
    },
    created () {},
    mounted () {
      this.setCurrentKey()

    },
    beforeDestroy () {
      this.$store.archivesStore.commit('getEntityTypeList')
    },
    destroyed () {},
    computed: {

      valueTypeList () {
        return this.$store.enumStore.state.valueTypeList
      },
      archivesTypeList () {
        var data=this.$store.archivesStore.getters.getArchivesTypeList

        return data;
      },
      priorityList () {
        return this.$store.orderGroupStore.state.priorityList;
      },
      priorityMatch () {
        return this.$store.orderGroupStore.state.priorityMatch;
      }
    },
    watch: {

    },
    methods: {
      //返回列表
      returnToList (num) {
        if(num!=0) {
          var d={
            'executorStatus': 'EXECUTORY',
            'executorType': 'ARTIFICIAL',
            'executorUser': localStorage.getItem('nowWedoSystemUserCode'),
            'orderNo': num,
            'pkid': this.nowDefecList.pkid
          }
          executorStatus(d).then(res => {
            if(res.code==200) {
              this.search();
            }
          })
        }
        this.defectsFlag=false
      },
      //创建工单
      createJob (item) {
        //  console.log("参数",item); 
        this.defectsFlag=true
        this.nowDefecList=item
      },
      //处理消缺
      handle_fn (item) {
        var d={
          'executorStatus': 'FINISHED',
          'executorType': 'ARTIFICIAL',
          'executorUser': localStorage.getItem('nowWedoSystemUserCode'),
          'pkid': item.pkid
        }
        executorStatus(d).then(res => {
          if(res.code==200) {
            this.search();
            this.$message({showClose: true,message: '处理成功',type: 'success'});
          } else {
            this.$message.error('处理失败');
          }
        })
      },

      //搜索
      searchName_fn () {
        var d={
          'standingBookId': this.nowEntity.id,
          'executorStatus': this.searchExecutorStatus,
          'executorType': this.searchExecutorType,
          'priority': this.searchPriority,
          'name': this.searchName,
          'pageNum': this.currentPage,
          "pageSize": this.currentSize

        }
        findDefectActionList(d).then(res => {
          this.dataList=copy(res.data.content);
          this.dataListCopy=copy(res.data.content)
          this.getNowPageDataList();
        })

      },
      setCurrentKey () {
        if(this.archivesTypeList.length!=0) {
          this.$refs['tree'].setCurrentKey(this.archivesTypeList[0].id);
          this.checkItem(this.archivesTypeList[0])
        }
      },
      //筛选
      filterNode (value,data) {
        if(!value) return true;
        return data.name.indexOf(value)!==-1;
      },
      autoSelectMethod (item) {
        if(!isempty(this.history)) {
          return this.history.id==item.id;
        } else {
          return item.entityName=='MisEntityType';
        }
      },
      // 选中设备树
      checkItem (item,node) {
        this.treeArr=node
        this.nowEntity=item;
        this.archivesList=[item]
        this.searchName=""
        this.searchPriority=null
        this.searchExecutorType=null
        this.searchExecutorStatus=null
        // this.form.typeCode = item.typeCode;
        // this.form.typeName = item.typeName;
        this.typeEnum=item.typeEnum
        this.history={};
        this.form={
          name: '',
          priority: ''
        };
        if(this.typeEnum==1) {
          var d={
            "typeCode": this.nowEntity.id,

          }
          getArchivesListByTypeCodeAndGroupNo(d).then(res => {
            res.data.forEach(item => {
              item.typeEnum=3
              item.typeName=item.name
            })
            this.$nextTick(() => {
              this.$refs['tree'].updateKeyChildren(this.nowEntity.id,res.data)
            })
          })
        }
        this.search();
      },
      // 查询
      search () {
        this.loading=true
        if(this.typeEnum==3) {
          var d={
            'standingBookId': this.nowEntity.id,
            'executorStatus': this.searchExecutorStatus,
            'executorType': this.searchExecutorType,
            'priority': this.searchPriority,
            'name': this.searchName,
            'pageNum': this.currentPage,
            "pageSize": this.currentSize

          }
          findDefectActionList(d).then(res => {
            this.dataList=copy(res.data.content);
            this.dataListCopy=copy(res.data.content)

            this.getNowPageDataList();
            this.loading=false
          })

          // this.$api.workDefectApi.findDefectListByArchivesId(this.nowEntity.id, respon => {
          //       this.dataList = copy(respon[0].defectList);
          //       this.dataListCopy = copy(respon[0].defectList)
          //       this.getNowPageDataList();
          // });
        } else {

          this.$api.workDefectApi.findDefectListByTypeCode(
            this.nowEntity.typeCode,
            respon => {
              this.dataList=copy(respon);
              this.dataListCopy=copy(respon)
              this.getNowPageDataList();
              this.loading=false
            },
            err => {
              this.$message(err);
              this.loading=false
            }
          );
        }

      },
      getNowPageDataList () {


      },

      // 新建消缺(新)弹窗
      add_ed () {
        // this.nameStr = ""
        // this.nameArr = []
        // var that = this
        // 	var recursiveFunction = function(){
        // 			const getStr = function(list){
        // 				list.forEach(function(row){
        // 					if(row.data.mainTypeCode != "" && row.parent != null){
        //             that.nameArr.push(row.data.typeName)
        // 						getStr([row.parent])
        // 					}
        // 				})
        // 			}
        // 			getStr([that.treeArr])
        // 		}
        // 		recursiveFunction()
        //   that.nameArr.reverse().forEach(item => {
        //     this.nameStr += item+' => '
        //   })

        //   var d = {
        //   "typeCode":this.nowEntity.id,

        //  }
        // getArchivesListByTypeCodeAndGroupNo(d).then(res => {
        //     this.archivesList = res.data
        // })
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["form"].clearValidate();
        });
        this.form={};
        this.form.standingBookId=this.nowEntity.id
      },
      //确定选择的台账
      deviceChang_fn (val) {
        var arr=this.archivesList.filter(item => item.id==val)
        this.nowArchives=arr[0]
      },
      //确定添加消缺
      add_fn (formName) {
        this.$refs[formName].validate(valid => {

          if(valid) {
            var d={
              name: this.form.name,
              defectType: "check",
              deviceNo: this.nowEntity.virtualDeviceNo,
              harm: this.form.harm,
              priority: this.form.priority,
              proposal: this.form.proposal,
              valueType: this.form.valueType,
              typeCode: this.nowEntity.typeCode,
              standingBookId: this.form.standingBookId,
              executorType: "UNKNOWN"

            }
            saveDefect(d).then(res => {
              if(res.success) {
                this.dialogVisible=false
                this.$message({showClose: true,message: '添加成功',type: 'success'});
                this.search();
              } else {
                this.$message.error('添加失败');
              }
            })

          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {

        this.dialogStatus="edit";
        this.form=Object.assign({},v);
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["form"].clearValidate();
        });
      },
      edit_fn () {
        this.$refs['form'].validate(valid => {
          if(valid) {
            saveDefect(this.form).then(res => {
              if(res.success) {
                this.dialogVisible=false
                this.$message({showClose: true,message: '修改成功',type: 'success'});
                this.search();
              } else {
                this.$message.error('修改失败');
              }

            })

          } else {
            return false;
          }
        });
      },

      // 删除消缺
      deleteDefect_fn (defectData) {
        this.$confirm(`此操作将永久删除 ${defectData.name}, 是否继续?`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            deleteDefect({'pkid': defectData.pkid}).then(res => {
              if(res.success) {
                this.$message({message: '删除成功！',type: 'success'});
                this.search();
              } else {
                this.$message({message: '删除失败！',type: 'error'});
              }
            })

          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      },
      newgetNowPageDataList () {
        // 当前页显示
        this.total=this.zhongArr.length;
        var result=this.zhongArr.filter((item,index) => {
          return index<this.currentPage*this.currentSize&&index>=(this.currentPage-1)*this.currentSize;
        });

      },
      handleSizeChange (val) {
        this.currentSize=val;
        this.newgetNowPageDataList();
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.newgetNowPageDataList();
      }
    },
    //过滤器
    filters: {

      //消缺等级
      priorityfun (val) {
        if(val=='Emergent') {
          return "紧急"
        } else if(val=='High') {
          return "高"
        } else if(val=='Standard') {
          return "标准"
        } else if(val=='Low') {
          return "低"
        } else {
          return val
        }
      },
      //消缺状态
      executorStatus_fn (val) {
        if(val=='INITIAL') {
          return "未处理"
        } else if(val=='EXECUTORY') {
          return "处理中"
        } else if(val=='FINISHED') {
          return "已完结"
        }
      },
      //消缺状态
      executorType_fn (val) {
        if(val=='ARTIFICIAL') {
          return "人工"
        } else if(val=='ORDER') {
          return "工单"
        } else if(val=='UNKNOWN') {
          return "未知"
        }
      },
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>

<style scoped lang="scss">
  .buttoned_box {
    display: flex;
  }

  .newobviateDefectsManage {
    .con {
      width: 100%;
      height: 100%;
      // background-color: #fff;
      display: flex;
      position: relative;

      .left-tree {
        width: 300px;
        height: 100%;
        box-sizing: border-box;
        padding: 12px;
        background-color: #fff;
        margin-right: 8px;
      }

      .right-tbale {
        width: calc(100% - 308px);
        height: 100%;
        background-color: #fff;
        padding: 2px 20px 20px 12px;
        box-sizing: border-box;
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }
    }

    .defects-create {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 10;
    }

    .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    // 巡检
    .patrol {
      p {
        width: 8px;
        height: 8px;
        background-color: #0DAE88;
        border-radius: 50%;
        margin-right: 8px;
        position: relative;
        top: -1px;
      }

      span {
        color: #0DAE88;
      }
    }

    // 检修
    .overhaul {
      p {
        width: 8px;
        height: 8px;
        background-color: #FF1D1D;
        border-radius: 50%;
        margin-right: 8px;
      }

      span {
        color: #FF1D1D;
      }
    }

    // 检修
    .chuli {
      p {
        width: 8px;
        height: 8px;
        background-color: #FF7C1D;
        border-radius: 50%;
        margin-right: 8px;
      }

      span {
        color: #FF7C1D;
      }
    }

    .mutongyong {
      display: inline-block;
      width: 36px;
      height: 22px;
      text-align: center;
      line-height: 22px;
    }

    //紧急
    .myemergent {
      color: #FF1D1D;
      background-color: #FFE7E7;
    }

    //高
    .myhigh {
      color: #BF458E;
      background-color: #FFE9F6;
    }

    //标准
    .mystandard {
      color: #5452C9;
      background-color: #E5E8FF;
    }

    //低
    .mylow {
      color: #2981D2;
      background-color: #DEF3FF;
    }
  }
</style>